import { NgModule } from '@angular/core';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { OfferEditComponent } from './offer-edit/offer-edit.component';
import { OfferUploadComponent } from './csv-import/offer-upload/offer-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ProductSelectDialogComponent } from './offer-edit/product-select-dialog/product-select-dialog.component';
import { CommonModule } from '@angular/common';
import { DiscountSelectDialogComponent } from './offer-edit/discount-select-dialog/discount-select-dialog.component';
import { CommentSelectDialogComponent } from './offer-edit/comment-select-dialog/comment-select-dialog.component';
import { SwapsComponent } from './campaigns/swaps/swaps.component';
import { EditTagsDialogComponent } from './campaigns/edit-tags-dialog/edit-tags-dialog.component';
import { RemoveOfferDialogComponent } from './campaigns/remove-offer-dialog/remove-offer-dialog.component';
import { OfferListComponent } from './offer-list/offer-list.component';
import { FilePondModule, registerPlugin } from 'ngx-filepond';
import { CsvUploadErrorsComponent } from './csv-upload-errors/csv-upload-errors.component';
import { OfferWithdrawnComponent } from './offer-withdrawn/offer-withdrawn.component';
import { WithdrawOffersDialogComponent } from './offer-list/witdraw-offers-dialog/withdraw-offers-dialog.component';
import { CsvImportComponent } from './csv-import/csv-import.component';
import { MassStatusChangeDialogComponent } from 'app/modules/offers/offer-list/mass-status-change-dialog/mass-status-change-dialog.component';
import { MassTagsChangeDialogComponent } from 'app/modules/offers/offer-list/mass-tags-change-dialog/mass-tags-change-dialog.component';
import { OfferInitialCsvDialogComponent } from './offer-list/offer-initial-csv/offer-initial-csv-dialog.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MassOffersEditComponent } from './offer-list/mass-offers-edit/mass-offers-edit.component';
import { ConfirmOffersEditDialogComponent } from './offer-list/mass-offers-edit/confirm-offers-edit-dialog/confirm-offers-edit-dialog.component';
import { PipesModule } from '../../pipes/pipes.module';

import * as FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import * as FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginFileEncode);

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    CommonModule,
    FilePondModule,
    SharedModule,
    TranslateModule,
    PipesModule
  ],
  declarations: [
    CampaignsComponent,
    OfferEditComponent,
    ProductSelectDialogComponent,
    DiscountSelectDialogComponent,
    CommentSelectDialogComponent,
    SwapsComponent,
    EditTagsDialogComponent,
    WithdrawOffersDialogComponent,
    RemoveOfferDialogComponent,
    ConfirmOffersEditDialogComponent,
    CsvImportComponent,
    OfferListComponent,
    OfferUploadComponent,
    OfferWithdrawnComponent,
    CsvUploadErrorsComponent,
    MassStatusChangeDialogComponent,
    MassTagsChangeDialogComponent,
    OfferInitialCsvDialogComponent,
    MassOffersEditComponent
  ],
  entryComponents: [
    ProductSelectDialogComponent,
    DiscountSelectDialogComponent,
    CommentSelectDialogComponent,
    EditTagsDialogComponent,
    WithdrawOffersDialogComponent,
    RemoveOfferDialogComponent,
    ConfirmOffersEditDialogComponent,
    MassStatusChangeDialogComponent,
    MassTagsChangeDialogComponent,
    OfferInitialCsvDialogComponent
  ]
})
export class OffersModule {}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offers.module.ts